import { Icon } from "@material-ui/core";
import RouterLink from "Components/RouterLink/RouterLink";
import { RouterLinkType } from "Enums/RouterLinkType";
import * as React from "react";
import i18n from "Translations/i18n";
import styles from "./TaskTemplateListOverviewHeader.scss";

const TaskTemplateListOverviewHeader: React.FunctionComponent<{}> = () => (
    <div className={styles.taskTemplateListOverviewHeader}>
        <RouterLink type={RouterLinkType.default} to="/tasktemplates" className={styles.backToOverview}>
            <Icon className={styles.icon}>arrow_back</Icon>
            {i18n.t("tasks.backToOverview")}
        </RouterLink>
        <h1>{i18n.t("tasks.listOverviewTitle")}</h1>
    </div>
);

export default TaskTemplateListOverviewHeader;


// WEBPACK FOOTER //
// ./src/Components/Pages/TaskTemplateListOverview/TaskTemplateListOverviewHeader/TaskTemplateListOverviewHeader.tsx